import { Capacitor } from "@capacitor/core";
import { IndexedDbOutboxStore } from "./indexedDbOutboxStore";
import type { OutboxStore } from "./types";

export async function createOutboxStore(): Promise<OutboxStore> {
  if (Capacitor.isNativePlatform()) {
    const { NativeSqliteOutboxStore } = await import("./nativeSqliteOutboxStore");
    return new NativeSqliteOutboxStore();
  }

  return new IndexedDbOutboxStore();
}
